const actions = {
    GST_TRANSACTION_DETAILS_START: 'GST_TRANSACTION_DETAILS_START',
    GST_TRANSACTION_DETAILS_SUCCESS: 'GST_TRANSACTION_DETAILS_SUCCESS',
    GST_TRANSACTION_DETAILS_FAILURE: 'GST_TRANSACTION_DETAILS_FAILURE',

    DELIVERY_DETAILS_START: 'DELIVERY_DETAILS_START',
    DELIVERY_DETAILS_SUCCESS: 'DELIVERY_DETAILS_SUCCESS',
    DELIVERY_DETAILS_FAILURE: 'DELIVERY_DETAILS_FAILURE',
};

export default actions;